export default __webpack_public_path__ + "static/media/blue-majik.107acc14.png";